<!--
    Rendered unconditionally so the viewChild resolves before the modal is opened -- aix-modal shows
    nothing of its own until openModal() is called.
-->
<aix-modal
    #whatsNewModal
    [closeable]="true"
    [modalTitle]="modalTitle"
    [modalType]="'interactive'"
    [modalZIndex]="7000"
    [buttonOptions]="buttonOptions"
>
    <ng-template>
        @if (loading) {
        <div class="u-mb16 ph-unmask">Loading…</div>
        } @else if (error) {
        <div class="u-mb16 ph-unmask">Sorry, we couldn’t load What’s New right now. Please try again.</div>
        } @else if (srcdoc) {
        <!--
            Each page is rendered in its OWN sandboxed frame so the roadmap's standalone styling
            survives (it is not the app's styling). sandbox="allow-scripts" lets the page's own JS
            and the injected nav-interception script run; the absence of allow-same-origin keeps it
            boxed off from the app (allow-scripts WITHOUT allow-same-origin is the safe pairing). The
            two popup flags let the content's target="_blank" links open and keep the opened tab out
            of the sandbox. The frame is a fixed, scrollable height -- a cross-origin frame can't be
            measured from out here, so it scrolls internally.
        -->
        <iframe
            class="whats-new-frame"
            title="What’s New on AIX"
            sandbox="allow-scripts allow-popups allow-popups-to-escape-sandbox"
            [srcdoc]="srcdoc"
            (load)="onFrameLoad($event)"
        ></iframe>
        }
    </ng-template>
</aix-modal>
